import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import http from '@/common/js/https'
import utils from '@/common/js/utils'
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import ElementPlus from 'element-plus' //全局引入
import zhCn from "element-plus/es/locale/lang/zh-cn";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import qs from 'qs';
import videojs from "video.js";
import "video.js/dist/video-js.css";
import './assets/global.css'; // 引入全局 CSS 文件
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
const locale = zhCn
app.config.globalProperties.$http  = http
app.config.globalProperties.$qs  = qs
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$video = videojs;
router.beforeEach(async (to) => {
  document.title = '海职院教学资源平台'
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
});
app.use(Lazyload, {
  lazyComponent: true,
});
app.use(router);
app.use(Vant);
app.use(ElementPlus, {locale})
app.mount('#app');


